import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { canAccessCrmRoute } from '../utils/crmPermissions';

function ProtectedRoute({ children, permission, anyOfPermissions, adminOnly = false }) {
  const { user, permissionsLoading } = useAuth();

  if (!user) return <Navigate to="/login" replace />;

  const permissionCodes = [
    ...(permission ? [permission] : []),
    ...(Array.isArray(anyOfPermissions) ? anyOfPermissions : [])
  ];

  // If permissions are still loading, don't decide yet (avoid false denies)
  if ((permissionCodes.length > 0 || adminOnly) && permissionsLoading) {
    return null;
  }

  if (!canAccessCrmRoute(user, { permission, anyOfPermissions, adminOnly })) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedRoute;
